export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/tmp/deploy-1772092115/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/tmp/deploy-1772092115/src/pages/[...path].vue'),
    /* no children */
    meta: {
      "layout": "error",
      "requiresAuth": false
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/tmp/deploy-1772092115/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "login",
      "requiresAuth": false
    }
  },
  {
    path: '/sign-up',
    name: '/sign-up',
    component: () => import('/tmp/deploy-1772092115/src/pages/sign-up.vue'),
    /* no children */
    meta: {
      "layout": "sign-up",
      "requiresAuth": false
    }
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

